import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ButtonDanger, ButtonPrimary, Container, Table } from './styles';
import './style.css';  

export const Divergencia = () => {
  const [divergencias, setDivergencias] = useState([]);
  const { id, periodo } = useParams();

  useEffect(() => {
    fetch(`https://inventario.dracherie.com.br/api_cherie/componentes_divergencia/index.php?id_loja=${id}&id_periodo=${periodo}`)
      .then(response => response.json())
      .then(data => {
        if (data && data.records) {
          const records = Object.values(data.records);
          setDivergencias(records);
        }
      })
      .catch(error => console.error('Erro ao obter divergências:', error));
  }, [id, periodo]);

  const handleApagarClick = async (enderecoId) => {
    try {
      const response = await fetch('https://inventario.dracherie.com.br/api_cherie/componentes_divergencia/excluir_endereco.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          enderecoId: enderecoId,
        }),
      });

      const result = await response.json();

      if (result.success) {
        console.log(`Endereço com ID ${enderecoId} excluído com sucesso`);
        setDivergencias(prevDivergencias => prevDivergencias.filter(divergencia => divergencia.id !== enderecoId));
      } else {
        console.error('Erro ao excluir o endereço:', result.message);
      }
      window.location.reload();
    } catch (error) {
      console.error('Erro na requisição para excluir o endereço:', error);
    }
  };

  return (
    <Container>
      <div className="topnav" id="myTopnav">
      <a href="#" className="icon" onClick={(e) => { e.preventDefault(); document.getElementById("myTopnav").classList.toggle("responsive"); }}>
  &#9776;
</a>

        <a href={`/conferencia/${id}/${periodo}`} className="active">Conferencia</a>
        <a href={`/home/${id}/${periodo}`}>Inventariar</a>
      </div>
      
      <div className="content"> 
        <Table>
          <thead>
            <tr>
              <th>Endereco</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            {divergencias.map(divergencia => (
              <tr key={divergencia.id}>
                <td>{divergencia.endereco}</td>
                <td>
                  <ButtonDanger className='btn_divergencia' onClick={() => handleApagarClick(divergencia.endereco)}>
                    Apagar
                  </ButtonDanger>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
};

export default Divergencia;
